import {Action} from '@ngrx/store';

export const UPDATESTATE   = 'UPDATESTATE';

export function searchState (state = {}, action: Action) {
  switch(action.type){
    case UPDATESTATE:
      state = action.payload;
      return state;

    default:
      state={
        "total": null,
        "result": null,
        "pageNum": 1,
        "searchTerm" : null,
        "searchBy" : "all",
        "filterResultsBy" : "All Items",
        "typeaheadSuggest" : "allSuggest",
        "state": null,
        "stateSelectedAbbr": null,
        "cities" : [],
        "counties": [],
        "isStateSelected" : false,
      };
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/search/reducers/search-state.ts